import React, { useState, createContext, useContext } from 'react';
import Account from './Account';
import Error from './Error';
import Success from './Success';
import ConfigurableProduct from './ConfigurableProduct';
import CustomerAddress from './CustomerAddress';
import Cart from './Cart';
import MergeCarts from './MergeCarts';
import WishLists from './WishLists';
import NotificationPreferencesReadMore from './NotificationPreferencesReadMore';
import Vip from './Vip';
import SmsPhone from './SmsPhone';
import VipCreateAccount from './VipCreateAccount';
import TermsAndConditions from './TermsAndConditions';
import ImageZoom from './ImageZoom';
import ProductsForRecipe from './ProductsForRecipe';
import CookieConsent from './CookieConsent';
import DeleteWishList from './DeleteWishList';

const MODALS_TYPES = {
    ACCOUNT: 'account',
    ERROR: 'error',
    SUCCESS: 'success',
    CONFIGURABLE_PRODUCT: 'configurableProduct',
    CUSTOMER_ADDRESS: 'customerAddress',
    CART: 'cart',
    MERGE_CARTS: 'mergeCarts',
    WISH_LISTS: 'wishLists',
    NOTIFICATION_PREFERENCES_READ_MORE: 'notificationPreferencesReadMore',
    VIP: 'vip',
    SMS_PHONE: 'smsPhone',
    VIP_CREATE_ACCOUNT: 'vipCreateAccount',
    TERMS_ANS_CONDITIONS: 'termsAndConditions',
    IMAGE_ZOOM: 'imageZoom',
    PRODUCTS_FOR_RECIPE: 'productsForRecipe',
    COOKIE_CONSENT: 'cookieConsent',
    DELETE_WISH_LIST: 'deleteWishList',
};

const MODALS_COMPONENTS = {
    [MODALS_TYPES.ACCOUNT]: Account,
    [MODALS_TYPES.ERROR]: Error,
    [MODALS_TYPES.SUCCESS]: Success,
    [MODALS_TYPES.CONFIGURABLE_PRODUCT]: ConfigurableProduct,
    [MODALS_TYPES.CUSTOMER_ADDRESS]: CustomerAddress,
    [MODALS_TYPES.CART]: Cart,
    [MODALS_TYPES.MERGE_CARTS]: MergeCarts,
    [MODALS_TYPES.WISH_LISTS]: WishLists,
    [MODALS_TYPES.NOTIFICATION_PREFERENCES_READ_MORE]: NotificationPreferencesReadMore,
    [MODALS_TYPES.VIP]: Vip,
    [MODALS_TYPES.SMS_PHONE]: SmsPhone,
    [MODALS_TYPES.VIP_CREATE_ACCOUNT]: VipCreateAccount,
    [MODALS_TYPES.TERMS_ANS_CONDITIONS]: TermsAndConditions,
    [MODALS_TYPES.IMAGE_ZOOM]: ImageZoom,
    [MODALS_TYPES.PRODUCTS_FOR_RECIPE]: ProductsForRecipe,
    [MODALS_TYPES.COOKIE_CONSENT]: CookieConsent,
    [MODALS_TYPES.DELETE_WISH_LIST]: DeleteWishList,
};

const ModalsContext = createContext({});
const useModalsContext = () => useContext(ModalsContext);

const ModalsContextProvider = ({ children }) => {
    const [store, setStore] = useState({
        modalType: '',
        modalProps: {},
    });
    const { modalType, modalProps } = store;

    const showModal = (modalType, modalProps) => {
        setStore({
            ...store,
            modalType,
            modalProps,
        });
    };

    const hideModal = () => {
        setStore({
            ...store,
            modalType: '',
            modalProps: {},
        });
    };

    const renderComponent = () => {
        const ModalComponent = MODALS_COMPONENTS[modalType];

        if (!modalType || !ModalComponent) {
            return null;
        }

        return <ModalComponent {...modalProps} />;
    };

    return (
        <ModalsContext.Provider value={{ store, showModal, hideModal, MODALS_TYPES }}>
            {renderComponent()}
            {children}
            <div id="modal" />
        </ModalsContext.Provider>
    )
};

export { useModalsContext };

export default ModalsContextProvider;
